import { render, staticRenderFns } from "./ip-allocation.vue?vue&type=template&id=18180eb9&scoped=true"
import script from "./ip-allocation.vue?vue&type=script&lang=js"
export * from "./ip-allocation.vue?vue&type=script&lang=js"
import style0 from "./ip-allocation.vue?vue&type=style&index=0&id=18180eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18180eb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VRow})
